"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_1 = __importDefault(require("@App/navigation"));
const suggestion_status_1 = require("@Components/MatchComponents/v2/suggestion-status");
const Status_1 = __importDefault(require("@Components/Status"));
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importDefault(require("react"));
const param_1 = require("@App/navigation/param");
const LinkedStatusComponent = ({ count, rhId, status }) => (react_1.default.createElement(react_router_dom_1.Link, { to: {
        pathname: navigation_1.default.rightholder.matchClaim.matchHistory(rhId),
        search: `?${param_1.SEARCH_PARAM.matchHistoryFilter}=${status}`,
    } },
    react_1.default.createElement(Status_1.default, { withCount: true, status: suggestion_status_1.SUGGESTION_STATUS_VALUES[status], big: false, count: count, circleFirst: true })));
exports.default = LinkedStatusComponent;
